import React from "react";
import { useSearchParams } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useIntl } from "react-intl";
export function Pagination({ max, className }) {
    const [search, setSearch] = useSearchParams();
    const { formatMessage } = useIntl();
    const parsed = parseInt(search.get("page") || "1");
    const safePage = Number.isNaN(parsed) ? 1 : parsed;
    const current = max > 0 ? (safePage < 1 ? 1 : safePage > max ? max : safePage) : 1;
    const atStart = current <= 1;
    const atEnd = current === max || max === 0;
    const updatePage = (nextIndex) => {
        if (max > 0) {
            const clamped = nextIndex < 1 ? 1 : nextIndex > max ? max : nextIndex;
            search.set("page", clamped.toString());
            setSearch(search);
        }
    };
    const arrowClass = "inline-flex items-center justify-center rounded-lg p-2 cursor-pointer text-gray-600 " +
        "hover:bg-sunken hover:text-brand-700 pressable focus-ring tap-target " +
        "disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent disabled:hover:text-gray-400";
    return (<div className={`flex items-center justify-center ${className ?? ""}`}>
            <button type={"button"} aria-label={formatMessage({ id: "previous", defaultMessage: "Previous page" })} className={arrowClass} disabled={atStart} onClick={() => updatePage(current - 1)}>
                <ChevronLeft className={"w-5 h-5"}/>
            </button>

            <div aria-live={"polite"} className="mx-4 text-base font-medium tabular-nums text-gray-700">
                <span className={"text-gray-900"}>{max > 0 ? current : 0}</span>
                <span className={"mx-1 text-gray-400"}>/</span>
                {max}
            </div>

            <button type={"button"} aria-label={formatMessage({ id: "next", defaultMessage: "Next page" })} className={arrowClass} disabled={atEnd} onClick={() => updatePage(current + 1)}>
                <ChevronRight className={"w-5 h-5"}/>
            </button>
        </div>);
}
//# sourceMappingURL=pagination.jsx.map